import { Alert, Box, Button, Stack, TextField } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { LoadingComponent } from "@gui/widgets/LoadingComponent";
import { AsyncStatus } from "@gui/widgets/A11y";
import { PageLayout } from "@gui/widgets/PageLayout";
import { RegisterProps } from "./register.types";
import { useRegisterViewModel } from "./register.vm";

export function Register(props: RegisterProps) {
	const vm = useRegisterViewModel(props);

	return (
		<PageLayout width="form">
			<Stack spacing={2} component="form" onSubmit={vm.handleSubmit} noValidate>
				<Box display="grid" gridTemplateColumns="repeat(2, minmax(0, 1fr))" gap={2}>
					<TextField
						variant="outlined"
						required
						disabled={vm.loading}
						fullWidth
						id="firstName"
						label="First Name"
						name="firstName"
						autoFocus
						onBlur={vm.handleFirstNameChange}
						data-sentry-component="First Name Field"
					/>
					<TextField
						variant="outlined"
						required
						disabled={vm.loading}
						fullWidth
						id="lastName"
						label="Last Name"
						name="lastName"
						onBlur={vm.handleLastNameChange}
						data-sentry-component="Last Name Field"
					/>
				</Box>
				<TextField
					variant="outlined"
					required
					error={!!vm.emailError}
					helperText={vm.emailError}
					disabled={vm.loading}
					fullWidth
					id="email"
					label="Email"
					name="email"
					autoComplete="email"
					onBlur={vm.handleEmailChange}
					data-sentry-component="Email Field"
				/>
				<TextField
					variant="outlined"
					error={!!vm.passwordError}
					helperText={vm.passwordError}
					required
					disabled={vm.loading}
					fullWidth
					name="password"
					label="Password"
					type="password"
					id="password"
					autoComplete="new-password"
					onBlur={vm.handlePasswordChange}
					data-sentry-component="Password Field"
				/>
				<TextField
					variant="outlined"
					error={!!vm.confirmPasswordError}
					helperText={vm.confirmPasswordError}
					required
					disabled={vm.loading}
					fullWidth
					name="Confirm password"
					label="Confirm Password"
					type="password"
					id="Confirm password"
					autoComplete="new-password"
					onBlur={vm.handleConfirmPasswordChange}
					data-sentry-component="Confirm Password Field"
				/>
				{/* Unlike Login's, this element genuinely populates — register.vm sets it for the
				    "email already exists" and generic-failure paths — so it is a real live region.
				    Mounted only when non-empty, so it is not a second ambiguous `getByRole("alert")`. */}
				{/* Above the submit, as on every auth page. The sign-in link is the row below. */}
				{vm.error && <Alert severity="error">{vm.error}</Alert>}
				<Button
					type="submit"
					fullWidth
					variant="contained"
					size="large"
					sx={{ mt: 1 }}
					disabled={vm.loading}
					data-sentry-component="Submit Button"
				>
					Register
				</Button>
				{vm.loading && (
					<Box display="flex" justifyContent="center" alignItems="center" aria-busy="true">
						<AsyncStatus state="loading" loadingText="Creating your account…" />
						<LoadingComponent />
					</Box>
				)}
				<Box display="flex" justifyContent="center" alignItems="center" gap={0.5} color="text.secondary">
					Already have an account?
					<Button component={RouterLink} to="/login" variant="text" disabled={vm.loading}>
						Sign in
					</Button>
				</Box>
			</Stack>
		</PageLayout>
	);
}
